import styled from '@emotion/styled'

import { LabelsListItem } from './LabelsListItem/LabelsListItem'

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledLabelsListItem = styled(LabelsListItem)`
  margin-top: 10px;
`

export {
  RootContainer,
  StyledLabelsListItem as LabelsListItem
}
